var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lv-table-cell",class:[("lv-table-cell-align-" + _vm.align)],style:(_vm.styles)},[(_vm.isFixed)?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }